
namespace RioERP.Masters {
    export class AttemptsColumns {
        static columnsKey = 'Masters.Attempts';
    }
}